import React from 'react';
import { AnimatePresence, motion, MotionConfig } from 'framer-motion';
import { FirebaseProvider } from './src/components/Context/Firebase';

export const wrapRootElement = ({ element }) => (
  <FirebaseProvider>
    <MotionConfig reducedMotion="user">
      {element}
    </MotionConfig>
  </FirebaseProvider>
);

export const wrapPageElement = ({ element, props }) => (
  <AnimatePresence mode="wait">
    <motion.div
      key={props.location.pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      {element}
    </motion.div>
  </AnimatePresence>
);